import React from 'react';
import { useSelector } from 'react-redux';

import { useLabels, usePrefs, useFlags } from 'wsm-common-data';
import { DetailedIncentives, filterIncentiveIds } from 'wsm-incentive-display';
import { ErrorBoundary } from 'wsm-error-boundary';

import '../global-sass/main.scss';

const Widget = () => {
	const prefs = usePrefs();
	const labels = useLabels();
	const flags = useFlags();

	const wisIncentives = useSelector((state) => state.wisIncentives) || {};
	const account = useSelector((state) => state.account);
	const vehicleData = useSelector((state) => state.wisVehicle) || {};
	const {
		showIncentives,
		sidebarPricingDisclaimer,
		incentiveTitleDisplay,
		incentiveTitleCustom,
		incentiveDisplayGrouping,
		showDealerRegularIncentives,
		showDealerConditionalIncentives,
		showOemNationalIncentives,
		showOemConditionalIncentives
	} = prefs;

	const incentivesEnabled =
		wisIncentives &&
		Object.keys(wisIncentives).length > 0 &&
		showIncentives === 'true';
	const sidebarDisclaimer = sidebarPricingDisclaimer;
	const filteredIncentives = incentivesEnabled
		? filterIncentiveIds(wisIncentives, Object.keys(wisIncentives))
		: {};
	const useSpotIconWithMultipleIncentivesLink =
		flags['enable-restyle-wsm-incentive-display-widget'];
	const useOnPageIncentive = flags['use-on-page-incentives'];
	return (
		<ErrorBoundary newRelicPageAction="WS DETAILED INCENTIVES ERROR BOUNDARY">
			<>
				{incentivesEnabled && (
					<DetailedIncentives
						incentives={filteredIncentives}
						accountInfo={account}
						vehicleData={vehicleData}
						incentiveTitleDisplay={incentiveTitleDisplay}
						incentiveTitleCustom={incentiveTitleCustom}
						incentiveDisplayGrouping={incentiveDisplayGrouping}
						showDealerRegularIncentives={
							showDealerRegularIncentives === 'true'
						}
						showDealerConditionalIncentives={
							showDealerConditionalIncentives === 'true'
						}
						showOemNationalIncentives={
							showOemNationalIncentives === 'true'
						}
						showOemConditionalIncentives={
							showOemConditionalIncentives === 'true'
						}
						useSpotIconWithMultipleIncentivesLink={
							useSpotIconWithMultipleIncentivesLink
						}
						useOnPageIncentive={useOnPageIncentive}
					/>
				)}
				{sidebarDisclaimer && <>{labels.getHTML(sidebarDisclaimer)}</>}
			</>
		</ErrorBoundary>
	);
};

export default Widget;
